import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
    DocumentList,
    HowToDocumentCategoryGetOne,
    HowToDocumentCategoryList,
    HowToDocumentSubCategoryGetOne,
    HowToDocumentSubCategoryList
} from './thunk'

export const categoryForm = {
    category_id: null,
    category_name: '',
    is_published: 1,
    display_order: ''
}
export const categorySubCategoryForm = {
    sub_category_id: null,
    sub_category_name: '',
    category_id: null,
    is_published: 1,
    display_order: ''
}

// const documentUploadForm = {
//     document_id: null,
//     document_title: '',
//     document_file: null,
//     file1: null,
//     video_url: '',
//     display_order: null
// }

export const initialState = {
    HowToDocumentCategory: {
        list: [],
        form: categoryForm,
        loading: false
    },
    HowToDocumentSubCategory: {
        list: [],
        form: categorySubCategoryForm,
        loading: false
    },
    DocumentUpload: {
        list: [],
        loading: false
    }
}
const HowToDocument = createSlice({
    name: '@howToDocument',
    initialState,
    reducers: {
        addMoreDocumentUpload: (state) => {
            state.DocumentUpload.list.push({
                document_id: null,
                document_title: '',
                document_file: null,
                file1: null,
                video_url: '',
                display_order: null
            })
        },
        removeUploadDocument: (state, action) => {
            const list = state.DocumentUpload.list.filter((x, i) => i !== action.payload)

            state.DocumentUpload.list =
                _.size(list) === 1
                    ? [
                          {
                              document_id: null,
                              document_title: '',
                              document_file: null,
                              file1: null,
                              video_url: '',
                              display_order: null
                          }
                      ]
                    : list
        }
    },
    extraReducers: (builder) => {
        // Listing
        builder.addCase(HowToDocumentCategoryList.pending, (state) => {
            state.HowToDocumentCategory.loading = true
        })
        builder.addCase(HowToDocumentCategoryList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.HowToDocumentCategory.form = categoryForm
            state.HowToDocumentCategory.list = data
            state.HowToDocumentCategory.loading = false
        })
        builder.addCase(HowToDocumentCategoryList.rejected, (state) => {
            state.HowToDocumentCategory.loading = false
        })

        //

        builder.addCase(HowToDocumentCategoryGetOne.pending, (state) => {
            state.HowToDocumentCategory.loading = false
        })
        builder.addCase(HowToDocumentCategoryGetOne.fulfilled, (state, action) => {
            const { payload } = action

            const data = _.pick(payload?.data, Object.keys(categoryForm))
            state.HowToDocumentCategory.form = { ...data, is_published: Boolean(data.is_published) }
            state.HowToDocumentCategory.loading = false
        })
        builder.addCase(HowToDocumentCategoryGetOne.rejected, (state) => {
            state.HowToDocumentCategory.loading = false
        })

        // Sub Listing
        builder.addCase(HowToDocumentSubCategoryList.pending, (state) => {
            state.HowToDocumentSubCategory.loading = true
        })
        builder.addCase(HowToDocumentSubCategoryList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.HowToDocumentSubCategory.form = categorySubCategoryForm
            state.HowToDocumentSubCategory.list = data
            state.HowToDocumentSubCategory.loading = false
        })
        builder.addCase(HowToDocumentSubCategoryList.rejected, (state) => {
            state.HowToDocumentSubCategory.loading = false
        })

        //

        builder.addCase(HowToDocumentSubCategoryGetOne.pending, (state) => {
            state.HowToDocumentSubCategory.loading = false
        })
        builder.addCase(HowToDocumentSubCategoryGetOne.fulfilled, (state, action) => {
            const { payload } = action

            const data = _.pick(payload?.data, Object.keys(categorySubCategoryForm))

            state.HowToDocumentSubCategory.form = {
                ...data,
                is_published: Boolean(data.is_published)
            }
            state.HowToDocumentSubCategory.loading = false
        })
        builder.addCase(HowToDocumentSubCategoryGetOne.rejected, (state) => {
            state.HowToDocumentSubCategory.loading = false
        })

        // Document List
        builder.addCase(DocumentList.pending, (state) => {
            state.DocumentUpload.loading = true
        })
        builder.addCase(DocumentList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.DocumentUpload.list = data
            state.DocumentUpload.loading = false
        })
        builder.addCase(DocumentList.rejected, (state) => {
            state.DocumentUpload.loading = false
        })
    }
})

export const { addMoreDocumentUpload, removeUploadDocument } = HowToDocument.actions
export default HowToDocument.reducer
